<template>
  <ModalLegalBase ref="modal" v-model:open="open">
    <div class="bg-bgr-primary relative flex w-[90vw] max-w-[1152px] gap-2 rounded-lg p-1">
      <div class="h-[70dvh] w-full overflow-auto">
        <embed
          v-if="pendingDocument?.files"
          class="h-[inherit] rounded-lg"
          :src="pendingDocument?.urls[getLocale()]"
          type="application/pdf"
          width="100%"
        />
      </div>
      <aside class="flex max-w-86 flex-col gap-2 px-4 pt-3 pb-2">
        <h2 class="text-body-large-m">{{ t("legal_documents.title") }}</h2>
        <p
          v-if="pendingDocument && pendingDocument.changes"
          class="text-body-default"
          v-html="pendingDocument.changes[getLocale()]"
        />
        <div class="mt-auto flex flex-col gap-2 py-3">
          <div class="bg-bgr-secondary rounded-xl px-4 py-3">
            <SelectCheckbox
              v-model="consentChecked"
              :title="t('i_hereby_accept_document', { document: pendingDocument?.readable_type })"
              :error="error"
            />
          </div>
        </div>
        <footer class="pt-2">
          <Button :disabled="!consentChecked" :variant="ButtonVariant.Primary" class="w-fit" @click="updateConsent">
            {{ t("save_and_close") }}
          </Button>
        </footer>
      </aside>
      <Overlay v-if="loading" class="absolute inset-0" />
    </div>
  </ModalLegalBase>
</template>

<script setup lang="ts">
  const { pendingDocument, loading } = defineProps<{
    pendingDocument: any;
    loading: boolean;
  }>();

  const emit = defineEmits(["updateAccept"]);

  const { locale, t } = useI18n();
  const open = ref(true);
  const error = ref(false);

  const consentChecked = ref(false);

  const getLocale = () => {
    if (locale.value.toLowerCase().includes("da")) {
      return "da";
    } else {
      return "en";
    }
  };

  const updateConsent = () => {
    if (!consentChecked.value) {
      error.value = true;
    } else {
      emit("updateAccept", pendingDocument);
      consentChecked.value = false;
    }
  };
</script>
